export const AUTO_FUND_MINIMUM_AMOUNT = 2000;
export const AUTO_FUND_MINIMUM_THRESHOLD = 0;